import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, Divider, IconButton, Menu, MenuItem, Stack } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
/**
 * A responsive action menu. Shows a labelled, collapsed "⋮" menu on mobile (and
 * on desktop when `forceMenu` is set); otherwise a row of icon buttons.
 */
export const ResponsiveActionMenu = ({ actions, isMobile, forceMenu = false, }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    if (actions.length === 0)
        return null;
    if (isMobile || forceMenu) {
        return (_jsxs(Box, { sx: {
                minWidth: 0,
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
            }, children: [_jsx(IconButton, { onClick: handleMenuOpen, "aria-label": "Team actions", children: _jsx(MoreVertIcon, {}) }), _jsx(Menu, { anchorEl: anchorEl, open: open, onClose: handleMenuClose, anchorOrigin: { vertical: "bottom", horizontal: "right" }, transformOrigin: { vertical: "top", horizontal: "right" }, keepMounted: true, children: actions.flatMap((action, index) => {
                        const item = (_jsxs(MenuItem, { component: action.to ? Link : "li", to: action.to, onClick: () => {
                                handleMenuClose();
                                action.onClick?.();
                            }, sx: action.destructive ? { color: "error.main" } : undefined, children: [_jsx(Box, { component: "span", sx: { mr: 1, display: "flex" }, children: action.icon }), action.label] }, index));
                        return action.divider
                            ? [_jsx(Divider, {}, `divider-${index}`), item]
                            : [item];
                    }) })] }));
    }
    return (_jsx(Stack, { direction: "row", spacing: 1, children: actions.map((action, index) => action.to ? (_jsx(IconButton, { component: Link, to: action.to, "aria-label": action.label, title: action.label, children: action.icon }, index)) : (_jsx(IconButton, { onClick: action.onClick, "aria-label": action.label, title: action.label, children: action.icon }, index))) }));
};
